console.log("-- PB --");

window.addEventListener("message", function (event) {
  //console.log("PB message received:", event.origin, event.data);

  const allowedOrigins = [
    "https://live.productbuilder.cloud",
    "https://accept.productbuilder.cloud",
  ];

  if (allowedOrigins.indexOf(event.origin) === -1) {
    return;
  }

  if (
    event.data &&
    event.data.type === "REDIRECT_TO_CHECKOUT" &&
    event.data.url
  ) {
    console.log("PB redirecting to:", event.data.url);
    window.location.href = event.data.url;
  }
});
